var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 9.91667L12.25 12.25M1.75 6.41667C1.75 7.65434 2.24167 8.84133 3.11684 9.7165C3.992 10.5917 5.17899 11.0833 6.41667 11.0833C7.65434 11.0833 8.84133 10.5917 9.7165 9.7165C10.5917 8.84133 11.0833 7.65434 11.0833 6.41667C11.0833 5.17899 10.5917 3.992 9.7165 3.11684C8.84133 2.24167 7.65434 1.75 6.41667 1.75C5.17899 1.75 3.992 2.24167 3.11684 3.11684C2.24167 3.992 1.75 5.17899 1.75 6.41667Z",
    stroke: "#070707",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.6da9798c5bc2f1c6dc372cfa51eacecd.svg";
export { ForwardRef as ReactComponent };